export const TICKET_STATUS_ANSWERED = {
    id: 1,
    name: "answered"
};

export const TICKET_STATUS_SENDING = {
    id: 2,
    name: "sending"
};

export const TICKET_STATUS_SENT = {
    id: 3,
    name: "sent"
};

export const TICKET_STATUS_WAITING_FOR_ANSWER = {
    id: 4,
    name: "waiting"
};

export const TICKET_TYPE_FORMULA_CLAIM = {
    id: 1,
    name: "formula_claim"
};

export const TICKET_TYPE_FORMULA_REQUEST = {
    id: 2,
    name: "formula_request"
};

export const TICKET_TYPE_MESSAGE_TICKET = {
    id: 3,
    name: "message_ticket"
};

export const TICKET_TYPE_SERVICE_TICKET = {
    id: 4,
    name: "service_ticket"
};
